module.exports = __webpack_public_path__ + "static/media/curIndMetodos.4a94b672.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/curIndMetodos.png
// module id = 975
// module chunks = 0